import React, { useEffect, useState } from 'react';
import './About.scss';

const About = () => {
    const [displayedText, setDisplayedText] = useState('');
    const [startAnimation, setStartAnimation] = useState(false);
    const fullText = "A self-taught web developer, based in Copenhagen. \nI like bringing ideas to life, whether it's coding, cooking, or playing music (though I only get paid for the first one 🙂). \nI'd love to work on anything that makes the world better — or at least doesn't harm it. \nFeel free to contact me any time!"; 

    useEffect(() => {
        // Wait for subtitle animation (2.5s) before starting
        const subtitleTimer = setTimeout(() => {
            setStartAnimation(true);
        }, 3000);

        return () => clearTimeout(subtitleTimer);
    }, []);

    useEffect(() => {
        if (!startAnimation) return;

        let currentIndex = 0;
        const interval = setInterval(() => {
            if (currentIndex <= fullText.length) {
                setDisplayedText(fullText.slice(0, currentIndex));
                currentIndex++;
            } else {
                clearInterval(interval);
            }
        }, 15);

        return () => clearInterval(interval);
    }, [startAnimation]);

    return (
        <div className="about-container">
            {!startAnimation ? <div className="loading-dot" /> : 
            <div className="about-text-wrapper">
                <p className="about-text">
                    {displayedText}
                </p>
            </div>}
            
        </div>
    );
};

export default About; 